import React from 'react';
import Card from '@material-ui/core/Card';
import DollarIcon from '@material-ui/icons/AttachMoney';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';


import DashboardCardIcon from './DashboardCardIcon';

const styles = {
  main: {
    flex: '1',
    marginRight: '1em',
    marginTop: 20,
  },
  card: {
    overflow: 'inherit',
    textAlign: 'right',
    padding: 16,
    minHeight: 52,
  },
};

const defaultBgColor = '#31708f';
const defaultTextColor = 'textSecondary';

const DashboardCard = ({
  value, title, icon, classes, bgColor, textColor,
}) => (
  <div className={classes.main}>
    <DashboardCardIcon Icon={icon || DollarIcon} bgColor={bgColor || defaultBgColor} />
    <Card className={classes.card} style={{ backgroundColor: bgColor || '#fff' }}>
      <Typography className={classes.title} style={{ color: textColor || defaultTextColor }}>
        {title}
      </Typography>
      <Typography variant="headline" component="h3" style={{ color: textColor || defaultTextColor }}>
        {value}
      </Typography>
    </Card>
  </div>
);

export default withStyles(styles)(DashboardCard);



// WEBPACK FOOTER //
// ./src/components/util/DashboardCard/DashboardCard.js